var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPaginationRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-pagination-refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/util/pagination/refresh"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-refresh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3666667,7.95833333 C15.1583333,6.75 13.5,6 11.6583333,6 C7.975,6 5,8.98333333 5,12.6666667 C5,16.35 7.975,19.3333333 11.6583333,19.3333333 C14.7666667,19.3333333 17.3583333,17.2083333 18.1,14.3333333 L16.3666667,14.3333333 C15.6833333,16.275 13.8333333,17.6666667 11.6583333,17.6666667 C8.9,17.6666667 6.65833333,15.425 6.65833333,12.6666667 C6.65833333,9.90833333 8.9,7.66666667 11.6583333,7.66666667 C13.0416667,7.66666667 14.275,8.24166667 15.175,9.15 L12.4916667,11.8333333 L18.325,11.8333333 L18.325,6 L16.3666667,7.95833333 Z",
    id: "Path",
    fill: "#40464D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaginationRefresh);
export default __webpack_public_path__ + "static/media/ic-pagination-refresh.1d9565c1452d04413105535897798050.svg";
export { ForwardRef as ReactComponent };